<template>
  <div
    class="user-profile-sidebar"
    :class="{ show: shallShowActiveChatContactSidebar }"
  >
    <!-- Header -->
    <header
      v-if="contact"
      class="user-profile-header border border-right-0 border-top-0"
    >
      <!-- <span class="close-icon">
        <feather-icon
          icon="XIcon"
          @click="$emit('update:shall-show-active-chat-contact-sidebar', false)"
        />
      </span>
      <div class="header-profile-sidebar">
        <div class="avatar box-shadow-1 avatar-xl avatar-border">
          <b-avatar size="70" :src="contact.avatar" />
          <span
            class="avatar-status-xl"
            :class="`avatar-status-${contact.isOnline ? 'online' : 'offline'}`"
          />
        </div>
        <h4 class="chat-user-name">
          {{ contact.name }}
        </h4>
      </div> -->
      <h2 class="p-1">Visitor Info</h2>
    </header>

    <!-- User Details -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="user-profile-sidebar-area scroll-area"
    >
      <!-- Personal Info -->
      <div class="personal-info pt-1">
        <!-- {{ contact }} -->
        <!-- <h6 class="section-label mb-1">{{ $t("chat.information") }}</h6> -->
        <ul class="list-unstyled">
          <li class="mb-1">
            <span class="align-middle">
              <strong>
              <feather-icon icon="UserIcon" size="20" class="mr-50" />
              {{ contact.name }}
            </strong>
             </span>
          </li>
          <li class="mb-1">
            <span class="align-middle">
              <strong>
                <feather-icon icon="MapPinIcon" size="20" class="mr-50" />
                {{ data.origin }}
              </strong>
            </span>
          </li>
          <li class="mb-1 font-weight-bold">
            <span class="align-middle">
              <strong>
                <feather-icon icon="MailIcon" size="20" class="mr-50" />
                {{ data.email }}
              </strong>
            </span>
          </li>
          <li class="mb-1">
            <span class="align-middle">
              <strong>
                <feather-icon icon="PhoneIcon" size="20" class="mr-50" />
                {{ data.phone }}
              </strong>
            </span>
          </li>
          <li v-if="contact.customer" class="mb-1">
            <span class="align-middle">
              <strong>
                <feather-icon icon="MonitorIcon" size="20" class="mr-50" />
                {{ contact.customer.device }}
              </strong>
            </span>
          </li>
          <li v-if="contact.customer" class="mb-1">
            <span class="align-middle">
              <strong>
                <feather-icon icon="StopCircleIcon" size="20" class="mr-50" />
                {{ contact.customer.ipAddress }}
              </strong>
            </span>
          </li>
        </ul>
      </div>
      <div />
      <!-- //TODO Add Translation-->
      <div class="personal-info mt-4">
        <h6 class="section-label mb-1">
          {{ $t('chat.assign') }}
        </h6>
      </div>

      <div class="personal-info mt-4">
        <div class="h-stack">
          <h6 class="section-label mb-1">
            {{ $t('chat.ticket-history') }}
          </h6>
          <div class="clickable-icon">
            <feather-icon icon="PlusIcon" size="28" class="mr-50" />
          </div>
        </div>

        <ul class="ticket-list">
          <li>
            <router-link to="/ticket?id=10"
              ><span>
                <strong> Some Problem </strong>
              </span>
            </router-link>
          </li>
        </ul>
      </div>

      <!-- <div class="personal-info mt-3" v-if="contact.rateData">
        <h6 class="section-label mb-1">{{ $t("chat.assign") }}</h6>
        <ul class="list-unstyled">
          <li class="mb-1">
            <span class="align-middle">
              <strong>
              <feather-icon icon="UserIcon" size="20" class="mr-50" />
            {{ $t("chat.assign") }} :  {{ data.firstName }} {{ data.lastName }}
            </strong>
            </span>
          </li>
          <li class="mb-1">
            <span class="align-middle">
              <strong>
              <feather-icon icon="FlagIcon" size="20" class="mr-50" />
              {{ contact.isOnline ? $t("chat.online") : $t("chat.offline") }}
            </strong>
            </span>
          </li>
          </ul>
      </div> -->
      <div v-if="contact.rateData" class="personal-info mt-5">
        <h6 class="section-label mb-1">
          {{ $t('chat.rating') }}
        </h6>
        <ul class="list-unstyled">
          <li class="mb-1">
            <feather-icon
              v-for="i in 5"
              :key="`star-${i}`"
              icon="StarIcon"
              size="22"
              class="rating-star mr-1"
              :class="{
                active: i <= contact.rateData.rate,
              }"
            />
          </li>
          <li v-if="contact.customer" class="mb-1">
            {{ contact.rateData.comment }}
          </li>
        </ul>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BAvatar } from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    // BSV
    BAvatar,

    // 3rd Party
    VuePerfectScrollbar,
  },
  props: {
    shallShowActiveChatContactSidebar: {
      type: Boolean,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },

  },
  data() {
    return {
      data: JSON.parse(localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)),
    }
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    return {
      perfectScrollbarSettings,
    }
  },
}
</script>
